import { request } from "../../../services/api.ts"

export interface GlobalFilterOption {
  value: string
  label: string
  children?: GlobalFilterOption[]
}

export interface GlobalFilterOptionsResponse {
  project: GlobalFilterOption[]
  pm: GlobalFilterOption[]
  client: GlobalFilterOption[]
  project_type: GlobalFilterOption[]
  project_status: GlobalFilterOption[]
  state: GlobalFilterOption[]
}

export type FilterOptionsSurface = "dashboard" | "reports"

export const getGlobalFilterOptions = (
  surface: FilterOptionsSurface = "dashboard"
) =>
  request.api.get<GlobalFilterOptionsResponse>("/dashboard/filter-options/", {
    surface
  })
